import React from 'react'

const IconFalse = () => {
  return (
    <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="#095BBD" />
      <path d="M15.8848 8.60352L12.8379 11.6504L15.8594 14.6719C16.1133 14.9004 16.1133 15.2812 15.8594 15.5098C15.6309 15.7637 15.25 15.7637 15.0215 15.5098L11.9746 12.4883L8.95312 15.5098C8.72461 15.7637 8.34375 15.7637 8.11523 15.5098C7.86133 15.2812 7.86133 14.9004 8.11523 14.6465L11.1367 11.625L8.11523 8.60352C7.86133 8.375 7.86133 7.99414 8.11523 7.74023C8.34375 7.51172 8.72461 7.51172 8.97852 7.74023L12 10.7871L15.0215 7.76562C15.25 7.51172 15.6309 7.51172 15.8848 7.76562C16.1133 7.99414 16.1133 8.375 15.8848 8.60352Z" fill="white" />
    </svg>
  )
}

export default IconFalse
